import { Link } from '@reach/router'
import React from 'react'
import { Button, useTheme } from 'webbook-airways'

export function Breadcrumb({ to, children }) {
  const theme = useTheme()
  const button = (
    <Button
      variant="text"
      disabled={!to}
      style={{
        minWidth: 0,
        color: to ? '#aaa' : theme.palette.primary.main,
        fontSize: 14,
        height: '100%',
        paddingLeft: 25,
        paddingRight: 25,
        borderRadius: 0,
        transform: 'skewX(-15deg)'
      }}
    >
      <div style={{ transform: 'skewX(15deg)' }}>{children}</div>
    </Button>
  )
  if (!to) return button
  return (
    <Link to={to} style={{ height: '100%' }}>
      {button}
    </Link>
  )
}
